module.exports = __webpack_public_path__ + "img/scroll-icon-5.f36f1981.png";